export default "__VITE_ASSET__Bm7OP_79__"